export class UserDashboardRoutingRouteNames {
    public static readonly TimelineDetail = 'timeline-detail';
    public static readonly TimelineDetailId = 'timelineDetailId';
    public static readonly TimelineDetailGroupId = 'timelineDetailGroupId';
}
